<template>
  <div class="section-obesity secondary">
    <img
      width="30"
      src="../assets/img/illustrations/bulp.png"
      class="bulp-illustration"
    />

    <div class="container">
      <SectionHeader
        title="O nadváze a obezitě"
        text="Obezita je chronické onemocnění vyžadující většinou celoživotní léčbu. V současnosti v ČR obezitou trpí pětina dospělé populace a téměř polovina žije s nadváhou. Jde o podceňované závažné metabolické onemocnění, které může vést k rozvoji těžkých komplikací, a dokonce i k předčasnému úmrtí. Obezita je celosvětovou pandemií.
."
      />

      <div class="primary--text">
        <v-row class="card" align="center" justify="center">
          <v-col md="5" cols="12" class="pa-0 pr-0 pr-md-4">
            <v-img
              max-width="100%"
              src="https://novocare.b-cdn.net/wegovy/obesity-image-min.png"
            ></v-img>
          </v-col>
          <v-col class="mb-12 mb-md-0 pa-6" md="7" cols="12">
            <h1 class="mb-4">Kdy mluvíme o obezitě?</h1>
            <div>
              Za normální hmotnost je považována hodnota BMI mezi 18,5 a 25.
              Většina populace mívá nadváhu, jejich BMI se pohybuje mezi 25 a
              30. Jako obezita prvního stupně se označuje BMI 30 až 35, obezitu
              druhého stupně pak představuje hodnota 35 až 40. Pokud BMI
              přesáhne 40, jde o obezitu třetího stupně. Orientačním ukazatelem
              nadváhy a nezdravého rozložení tuku v těle je i obvod pasu:
              zpozornět by měli muži při obvodu pasu nad 102 cm a ženy při
              hodnotě nad 88 cm.
            </div>

            <div class="text-right">
              <ButtonElement
                class="primary--text mt-12"
                color="secondary"
                text="Zjistit více"
                @click="$router.push({ name: 'AboutObesity' })"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "./SectionHeader.vue";
import ButtonElement from "./elements/ButtonElement.vue";

export default {
  components: { SectionHeader, ButtonElement },
  data() {
    return {
      educationCards: [
        {
          title: "O cukrovce 1. typu",
          route: "/cukrovka-typu-1",
          imgSmall: "https://novocare.b-cdn.net/HP/Cukrovka%201%201.png",
          perex:
            "<ul><li>Cukrovkou 1. typu trpí celosvětově téměř 54 milionů lidí, tedy asi 10&nbsp;% všech diabetiků.</li><li>Obvykle je diagnostikována u dětí nebo mladých dospělých.</li><li>Tělo při ní produkuje jen velmi malé nebo žádné množství inzulinu.</li><li>Jedinou léčbou je v současné době aplikace inzulinu.</li>",
        },
        {
          title: "O cukrovce 2. typu",
          route: "/cukrovka-typu-2",

          imgSmall: "https://novocare.b-cdn.net/HP/Cukrovka%202.png",
          perex:
            "<ul><li>Jde o metabolickou poruchu, při které tělo nevytváří dostatek inzulinu nebo na něj správně nereaguje.</li><li>Většinou vzniká v dospělosti, především v důsledku nesprávného životního stylu.</li><li>Primární příčinou cukrovky 2. typu je obezita. Kvůli tloustnutí populace se diabetes „dvojka“ stále častěji vyskytuje i u dětí.</li>",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.section-obesity {
  position: relative;
  padding-bottom: 4rem;
  padding: 7rem 0;

  .container {
    max-width: 60rem;
  }

  &__background {
    background: var(--v-primary-base);
    height: 30rem;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .bulp-illustration {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: -3rem;
  }

  .card {
    background: white;
    margin-top: 4rem;

    &-title {
      color: var(--v-primary-base);
    }

    &-text {
      margin: 1rem 0;
      min-height: 9rem;
    }
  }
}
</style>
